
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Picker, Popup } from 'vant';
Vue.use(Picker).use(Popup);
@Component
export default class PickerInput extends Vue {
  @Prop() title!: string;
  @Prop() PickerData!: object;
  @Prop({ default: '选择专业' }) placeholder!: string;
  src: string = require('../assets/trasf.png');
  value: string = '';
  showPicker: boolean = false;
  startPicker() {
    console.log('object');
    this.showPicker = true;
  }
  onConfirm(e: string, index: number) {
    this.$emit('selectData', e, index);
    this.value = e;
    this.showPicker = false;
  }
}
